module.exports = __webpack_public_path__ + "img/running_man.ed673773.svg";